import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Bag({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Bag.Outline {...props} /> : <Bag.Solid {...props} />;
}

Bag.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M14.5005 11.1018C14.5005 10.6876 14.8363 10.3518 15.2505 10.3518H15.2963C15.7105 10.3518 16.0463 10.6876 16.0463 11.1018C16.0463 11.516 15.7105 11.8518 15.2963 11.8518H15.2505C14.8363 11.8518 14.5005 11.516 14.5005 11.1018Z"
          fill="currentColor"
        />
        <path
          d="M9.41992 10.3518C9.00571 10.3518 8.66992 10.6876 8.66992 11.1018C8.66992 11.516 9.00571 11.8518 9.41992 11.8518H9.46569C9.8799 11.8518 10.2157 11.516 10.2157 11.1018C10.2157 10.6876 9.8799 10.3518 9.46569 10.3518H9.41992Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3322 1.52812C10.9843 1.52283 9.68976 2.05446 8.73461 3.00558C7.90519 3.8315 7.39101 4.91467 7.26974 6.06812C6.47636 6.06812 5.63159 6.33998 4.92541 6.95699C4.21645 7.57642 3.68755 8.50681 3.45602 9.75706C3.45351 9.77059 3.45138 9.78419 3.44962 9.79783L2.67257 15.8314C2.32227 18.1782 2.73677 19.8647 3.87676 20.9357C4.97941 21.9715 6.58049 22.25 8.16602 22.25H16.5138C18.1609 22.25 19.7277 21.8187 20.8042 20.7268C21.8999 19.6155 22.3487 17.9636 22.0442 15.8337L21.2669 9.79783C21.264 9.77581 21.2602 9.75393 21.2554 9.73225C20.7204 7.30402 19.1348 6.06812 17.4475 6.06812H17.3736C17.1085 3.5176 14.9527 1.52892 12.3322 1.52812ZM15.8619 6.06812C15.6057 4.34778 14.1223 3.02812 12.3306 3.02812L12.3274 3.02811C11.3782 3.02431 10.4657 3.39867 9.79302 4.06848C9.24674 4.61246 8.89466 5.31491 8.78153 6.06812H15.8619ZM4.1593 16.0306L4.93461 10.0106C5.11652 9.04802 5.50053 8.44638 5.91235 8.08657C6.32974 7.72188 6.81752 7.56812 7.26899 7.56812H17.4475C18.2818 7.56812 19.3615 8.15625 19.7835 10.0235L20.5571 16.0306L20.5586 16.0414C20.8201 17.8631 20.4083 18.9919 19.7361 19.6737C19.0437 20.3759 17.9332 20.75 16.5138 20.75H8.16602C6.68519 20.75 5.57688 20.4748 4.90379 19.8424C4.2693 19.2464 3.84135 18.1529 4.15716 16.046L4.1593 16.0306Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Bag.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M16.9739 6.77432C16.977 6.85189 16.9621 6.92913 16.9303 7H15.4932C15.4654 6.92794 15.4506 6.85153 15.4497 6.77432C15.4497 4.85682 13.8899 3.30238 11.9657 3.30238C10.0416 3.30238 8.48184 4.85682 8.48184 6.77432C8.49502 6.84898 8.49502 6.92535 8.48184 7H7.00989C6.9967 6.92535 6.9967 6.84898 7.00989 6.77432C7.12172 4.10591 9.32499 2 12.0049 2C14.6849 2 16.8882 4.10591 17 6.77432H16.9739Z"
          fill="currentColor"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9133 16.3147L20.1444 10.1201C19.676 7.90964 18.3503 7 17.0865 7H6.93171C5.65022 7 4.28034 7.84597 3.88264 10.1201L3.1049 16.3147C2.46858 20.8629 4.81062 22 7.86853 22H16.1585C19.2075 22 21.4789 20.3535 20.9133 16.3147ZM9.097 12.1486C8.60889 12.1486 8.21321 11.7413 8.21321 11.2389C8.21321 10.7366 8.60889 10.3293 9.097 10.3293C9.5851 10.3293 9.98079 10.7366 9.98079 11.2389C9.98079 11.7413 9.5851 12.1486 9.097 12.1486ZM14.002 11.2389C14.002 11.7413 14.3977 12.1486 14.8858 12.1486C15.3739 12.1486 15.7696 11.7413 15.7696 11.2389C15.7696 10.7366 15.3739 10.3293 14.8858 10.3293C14.3977 10.3293 14.002 10.7366 14.002 11.2389Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
